/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'spinner': {
    width: 38,
    height: 38,
    viewBox: '0 0 38 38',
    data: '<g transform="translate(1 1)" stroke-width="2" fill-rule="evenodd"><circle pid="0" stroke-opacity=".5" cx="18" cy="18" r="18"/><path pid="1" d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.5s" repeatCount="indefinite"/></path></g>'
  }
})
